export default "__VITE_ASSET__ygl1zWYJ__";